import React, { memo } from "react";

import { Alert, Strong, Text } from "@origin-digital/ods-core";

import { formatLabel } from "@/utils";

import { solarOutlook as content } from "../content.json";

type AlertPanelProps = {
  showAlert?: boolean;
  size: number;
};

export const AlertPanel = memo(
  ({ showAlert = true, size }: AlertPanelProps) => {
    const { label, testId } = content;

    return (
      showAlert && (
        <>
          <Alert data-id={testId.alert}>
            <Text>
              {formatLabel(
                label.alert,
                (value) => (
                  <Strong>{value}</Strong>
                ),
                `${size} kW`
              )}
            </Text>
          </Alert>
          <br />
        </>
      )
    );
  }
);
